<template>
  <base-layout>
    <h1 slot="header">
      {{ `app.pages.subscription` | trans }}
    </h1>
    <a slot="buttons" :href="routes.dashboard" class="btn btn-primary">
      <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
      Wróć
    </a>
    <v-alert v-if="last_subscription && reached_subscriptions_limit === false" :value="true" type="success">
      <h4>Uwaga</h4>
      <p>
        Twój abonament jest ważny do końca dnia: <strong>{{ expirationDate }}</strong
        >. Jeśli chcesz, możesz przedłużyć ważność swojego abonamentu, wybierając jedną z poniższych opcji. Pamiętaj, że
        możesz przedłużyć swój abonament w dowolnym momencie, a przy przejściu na wyższy plan, dostaniesz zniżkę za
        niewykorzystany okres.
      </p>
    </v-alert>
    <v-alert v-else-if="reached_subscriptions_limit === false" :value="true" type="warning">
      <h4>Uwaga</h4>
      <p>
        Nie posiadasz aktywnej subskrypcji. Wybierz jedną z poniższych opcji abonamentu i przedłuż ważność swojego
        konta.
      </p>
    </v-alert>
    <v-alert v-else :value="true" type="warning">
      <h4>Uwaga</h4>
      <p>
        Opłaciłeś już maksymalną ilość aktywnych subskrypcji i wykupienie kolejnej nie jest aktualnie możliwe.
        <br />Jeśli mimo wszystko chcesz przedłużyć abonament
        <a href="https://dietico.pl/kontakt" target="_blank">kliknij tutaj</a> i skontaktuj się z nami lub zadzwoń pod
        <a href="tel:+48535971889">+48 535 971 889</a>, a przygotujemy dla Ciebie atrakcyjną ofertę!
      </p>
    </v-alert>
    <v-app id="vuetify-app" class="no--wrap box box-success">
      <v-container id="subscriptions">
        <v-layout justify-center row wrap class="box-body">
          <a v-if="show_start_discount_banner" :href="routes.start_discount">
            <v-img
              class="elevation-3 mb-20"
              :width="1000"
              :height="300"
              src="/img/pages/start-discount/start_discount_subscription_select.png"
            ></v-img>
          </a>
          <v-flex xs10>
            <div class="subscriptions">
              <div class="subscriptions__container">
                <div class="container__item container__item--header"></div>
                <div class="container__item container__item--header">
                  <h2 class="item__title">STUDENT</h2>
                  <v-btn :disabled="subscription_buy_disabled" :href="routes.student_subscription" color="primary">
                    <v-icon>shopping_cart</v-icon>
                    {{ 'page.subscriptions.choose' | trans }}
                  </v-btn>
                </div>
                <div class="container__item container__item--header">
                  <h2 class="item__title">STANDARD</h2>
                  <v-btn :disabled="subscription_buy_disabled" :href="routes.standard_subscription" color="primary">
                    <v-icon>shopping_cart</v-icon>
                    {{ 'page.subscriptions.choose' | trans }}
                  </v-btn>
                </div>
                <div class="container__item container__item--header">
                  <h2 class="item__title">PREMIUM</h2>
                  <v-btn :disabled="subscription_buy_disabled" :href="routes.premium_subscription" color="primary">
                    <v-icon>shopping_cart</v-icon>
                    {{ 'page.subscriptions.choose' | trans }}
                  </v-btn>
                </div>
              </div>
              <div class="subscriptions__divider">
                <span class="divider__title">{{ 'page.subscriptions.price' | trans }}</span>
              </div>
              <div class="subscriptions__container">
                <div class="container__item container__item--title">
                  <span class="item__title">{{ 'page.subscriptions.month' | trans }}</span>
                </div>
                <div class="container__item container__item--price">
                  <span class="item__title">-</span>
                </div>
                <div class="container__item container__item--price">
                  <span class="item__title">{{ getPrice(24) | money | money_short }}</span>
                  <v-chip color="orange" text-color="white" small v-if="this.subscriptions[24].price !== '59.00'">
                    PROMOCJA ZAMIAST 59 ZŁ
                  </v-chip>
                  <span class="caption last--price" v-if="this.subscriptions[24].price !== '59.00'"
                    >Najniższa cena z 30 dni przed obniżką: 59 zł</span
                  >
                </div>
                <div class="container__item container__item--price">
                  <span class="item__title">{{ getPrice(21) | money | money_short }}</span>
                  <v-chip color="orange" text-color="white" small v-if="this.subscriptions[21].price !== '119.00'">
                    PROMOCJA ZAMIAST 119 ZŁ
                  </v-chip>
                  <span class="caption last--price" v-if="this.subscriptions[21].price !== '119.00'"
                    >Najniższa cena z 30 dni przed obniżką: 119 zł</span
                  >
                </div>
                <div class="container__item container__item--title">
                  <span class="item__title">{{ 'page.subscriptions.half_year' | trans }}</span>
                </div>
                <div class="container__item container__item--price">
                  <span class="item__title">{{ getPrice(28) | money | money_short }}</span>
                  <v-chip color="orange" text-color="white" small v-if="this.subscriptions[28].price !== '199.00'">
                    PROMOCJA ZAMIAST 199 ZŁ
                  </v-chip>
                  <span class="caption last--price" v-if="this.subscriptions[28].price !== '199.00'"
                    >Najniższa cena z 30 dni przed obniżką: 199 zł</span
                  >
                </div>
                <div class="container__item container__item--price">
                  <span class="item__title">{{ getPrice(25) | money | money_short }}</span>
                  <v-chip color="orange" text-color="white" small v-if="this.subscriptions[25].price !== '299.00'">
                    PROMOCJA ZAMIAST 299 ZŁ
                  </v-chip>
                  <span class="caption last--price" v-if="this.subscriptions[25].price !== '299.00'"
                    >Najniższa cena z 30 dni przed obniżką: 299 zł</span
                  >
                </div>
                <div class="container__item container__item--price">
                  <span class="item__title">{{ getPrice(22) | money | money_short }}</span>
                  <v-chip color="orange" text-color="white" small v-if="this.subscriptions[22].duration === 180">
                    <v-avatar class="orange darken-4">+</v-avatar>
                    1 Miesiąc gratis
                  </v-chip>
                  <v-chip color="orange" text-color="white" small v-if="this.subscriptions[22].price !== '599.00'">
                    PROMOCJA ZAMIAST 599 ZŁ
                  </v-chip>
                  <span class="caption last--price" v-if="this.subscriptions[22].price !== '599.00'"
                    >Najniższa cena z 30 dni przed obniżką: 599 zł</span
                  >
                </div>
                <div class="container__item container__item--title">
                  <span class="item__title">{{ 'page.subscriptions.year' | trans }}</span>
                </div>
                <div class="container__item container__item--price">
                  <span class="item__title">{{ getPrice(29) | money | money_short }}</span>
                  <v-chip color="orange" text-color="white" small v-if="this.subscriptions[29].price !== '299.00'">
                    PROMOCJA ZAMIAST 299 ZŁ
                  </v-chip>
                  <span class="caption last--price" v-if="this.subscriptions[29].price !== '299.00'"
                    >Najniższa cena z 30 dni przed obniżką: 299 zł</span
                  >
                </div>
                <div class="container__item container__item--price">
                  <span class="item__title">{{ getPrice(26) | money | money_short }}</span>
                  <v-chip color="orange" text-color="white" small v-if="this.subscriptions[26].price !== '479.00'">
                    PROMOCJA ZAMIAST 479 ZŁ
                  </v-chip>
                  <span class="caption last--price" v-if="this.subscriptions[26].price !== '479.00'"
                    >Najniższa cena z 30 dni przed obniżką: 479 zł</span
                  >
                </div>
                <div class="container__item container__item--price">
                  <span class="item__title">{{ getPrice(23) | money | money_short }}</span>
                  <v-chip color="orange" text-color="white" small v-if="this.subscriptions[23].duration === 365">
                    <v-avatar class="orange darken-4">+</v-avatar>
                    3 Miesiące gratis
                  </v-chip>
                  <v-chip color="orange" text-color="white" small v-if="this.subscriptions[23].price !== '999.00'">
                    PROMOCJA ZAMIAST 999 ZŁ
                  </v-chip>
                  <span class="caption last--price" v-if="this.subscriptions[23].price !== '999.00'"
                    >Najniższa cena z 30 dni przed obniżką: 999 zł</span
                  >
                </div>
              </div>
              <div class="subscriptions__divider">
                <span class="divider__title">{{ 'page.subscriptions.features' | trans }}</span>
              </div>
              <div class="subscriptions__container">
                <div class="container__item container__item--title">
                  <span class="item__title">Liczba wyglądów jadłospisu</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Dostęp do atrakcyjnych wydruków planów żywieniowych dla swoich pacjentów'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <span class="green--text title">7</span>
                </div>
                <div class="container__item">
                  <span class="green--text title">7</span>
                </div>
                <div class="container__item">
                  <span class="green--text title">12</span>
                </div>
                <div class="container__item container__item--title">
                  <span class="item__title">Drukowanie po posiłku</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Możliwość wydruku jadłospisu z podziałem na posiłki, np. wszystkie śniadania, następnie obiady i kolacje'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item container__item--title">
                  <span class="item__title">Wartości odżywcze na wydruku</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Możliwość ustawienia dowolnych 10 wartości odżywczych na wydruku jadłospisu'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Dzielona lista zakupów</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Możliwość wygenerowania listy zakupów z podziałem na dowolną ilość dni'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Globalna zamiana produktu</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Możliwość zamiany dowolnego produktu w całym jadłospisie z poziomu listy zakupów'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Wyszukiwarka produktów</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Możliwość wyszukiwania wykorzystanego produktu w widoku tygodniowym jadłospisu'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Udostępnianie danych</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Możliwość udostępnienia produktów, dań, szablonów diet, zaleceń żywieniowych i ankiet między 10 użytkownikami Dietico'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Zalecenia dla pacjentów</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Możliwość wpisania i załączenia zaleceń (np. ogólnych rad), które pojawią się na wydruku'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Gotowe jadłospisy</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        `Dostęp do ponad ${tooltip_information.menu_schema_count} gotowych jadłospisów przygotowanych przez naszych dietetyków`
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Szablony ankiet</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Możliwość tworzenia dowolnej ilości ankiet z własnymi pytaniami w wywiadzie pacjenta'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Łączenie listy zakupów</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Możliwość łączenia listy zakupów z różnych jadłospisów, także od innych pacjentów'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Kopiowanie całego dnia lub posiłku</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Możliwość kopiowania całego dnia lub posiłku do innego jadłospisu'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Skalowanie jadłospisów</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Możliwość automatycznej zmiany kaloryczności całego jadłospisu'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Kalendarz wizyt</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Możliwość zapisania ważnych wydarzeń i spotkań w ujęciu dziennym, tygodniowym i miesięcznym'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Edukacja</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Dostęp do materiałów edukacyjnych z dziedziny dietetyki/psychodietetyki'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Wysyłanie jadłospisu z programu</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Możliwość wysyłania jadłospisu pacjentowi na wskazany adres mailowy bezpośrednio z programu'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Brak loga Dietico</span>
                  <div class="item__desc">
                    <i class="fa fa-question-circle" v-tooltip="'Brak loga Dietico na wydruku jadłospisu'"></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="grey darken-1">close</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Sezonowość produktów</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Opcja filtrowania przepisów pod kątem ich sezonowości produktów'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Wyposażenie kuchenne</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Opcja filtrowania przepisów pod kątem wyposażenia kuchennego pacjenta'"
                    ></i>
                  </div>
                </div>

                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Produkty i dania</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        `Dostęp do bazy zawierającej ${tooltip_information.products_count} produktów i ${tooltip_information.food_count} przepisów w programie`
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Własne przepisy i produkty</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Tworzenie własnych produktów i przepisów bez limitu oraz możliwość ich kopiowania, edycji i zapisania we własnej bazie niedostępnej dla innych użytkowników'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Potrawy wieloporcjowe</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Możliwość wprowadzania dań wieloporcjowych z intuicyjnym planowaniem ich na kreatorze jadłospisu'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">WW, WBT, IG, ŁG</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Podgląd na wyliczone WW, WBT, IG, ŁG produktów i potraw oraz jadłospisów'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Miary domowe i kuchenne</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Dostęp do ponad 20 miar domowych w programie przypisanych do produktów'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Oznaczenie niewskazanych produktów i dań</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Oznaczenie produktów oraz dań nielubianych lub alergicznych dla pacjenta w kreatorze jadłospisu i w wyszukiwarce przepisów (na podstawie wywiadu z pacjentem)'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Oznaczenie powtarzanych potraw</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Oznaczenie potraw powtórzonych u pacjenta w poprzednich jadłospisach (informacja do 6 miesięcy wstecz) w celu uniknięcia ich powielania'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Wykorzystane produkty</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Podgląd na ilość wykorzystanych produktów w przygotowanym jadłospisie wraz z ilością miar domowych'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Podsumowanie jadłospisu</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Podsumowanie średnich wartości odżywczych oraz średniego pokrycia na zapotrzebowanie w jadłospisie'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Tagi w wyszukiwarce</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Możliwość precyzyjnego wyszukiwania przepisów za pomocą tagów opisujących posiłek (śniadanie, obiad itp), rodzaj dania (makarony, sałatki, pasty, kasze itp), diety (lekkostrawna, wegetariańska, bezglutenowa itp)'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Tworzenie szablonów</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Możliwość zapisywania swoich jadłospisów jako szablon i opisywanie ich dowolnymi tagami'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Lista zakupów</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Automatycznie generowana lista zakupów na wydruku dla pacjenta'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Wywiad żywieniowy</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Ankieta do przeprowadzenia wywiadu z pacjentem na wizycie'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Grupy produktów</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Możliwość wyboru całych grup produktów spożywczych w preferencjach żywieniowych pacjenta'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Pomiary pacjenta</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="'Możliwość wprowadzenia pomiarów pacjenta (z analizatora i obwodów pacjenta)'"
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Notatki z wizyty</span>
                  <div class="item__desc">
                    <i class="fa fa-question-circle" v-tooltip="'Możliwość wprowadzania notatek z wizyty pacjenta'"></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Logo i dane na wydruku</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Możliwość umieszczenia swojego logo i innych danych (telefon, strona www, e-mail) na wydruku dla pacjenta'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>

                <div class="container__item container__item--title">
                  <span class="item__title">Komentarze do jadłospisu</span>
                  <div class="item__desc">
                    <i
                      class="fa fa-question-circle"
                      v-tooltip="
                        'Możliwość dodawania komentarzy dla pacjenta na kreatorze do jadłospisu, posiłków i całych dni'
                      "
                    ></i>
                  </div>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
                <div class="container__item">
                  <v-icon color="primary">done</v-icon>
                </div>
              </div>
            </div>
          </v-flex>
          <v-alert v-if="!reached_subscriptions_limit" :value="true" type="info">
            <p>
              Chcesz abonament dłuższy niż <strong>ROK</strong>? A może interesuje Cię większa
              <strong>ILOŚĆ KONT</strong>? - <a href="https://dietico.pl/kontakt" target="_blank">kliknij tutaj</a> i
              skontaktuj się z nami lub zadzwoń pod <a href="tel:+48535971889">+48 535 971 889</a>, przygotujemy dla
              Ciebie atrakcyjną ofertę!
            </p>
          </v-alert>
        </v-layout>
      </v-container>
      <v-dialog v-model="invoice_missing" width="800" :persistent="true">
        <order-invoice-form @saved="invoice_missing = false">
          <template v-slot:title>
            <v-toolbar card dark color="primary">
              <v-toolbar-title>{{ 'app.invoice.data' | trans }}</v-toolbar-title>
            </v-toolbar>
          </template>
        </order-invoice-form>
      </v-dialog>
    </v-app>
  </base-layout>
</template>

<style lang="scss">
.v-alert {
  a:link {
    color: #fff;
    text-decoration: underline;
  }
  a:visited {
    color: #fff;
    text-decoration: underline;
  }
}

.last--price {
  margin: 14px 0 0;
}

.subscriptions {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 0 50px 0;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
}

.subscriptions__container {
  display: flex;
  flex-wrap: wrap;
}

.subscriptions__header {
  display: flex;
}

.container__item {
  width: 25%;
  padding: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  border-left: 1px solid rgba(0, 0, 0, 0.08);
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.container__item:first-child {
  border-left: none;
}

.container__item:last-child {
  border-right: none;
}

.container__item--header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 16px 0;
}

.container__item--title {
  justify-content: left;
  padding: 10px 43px 10px 10px;
}
.container__item--price {
  flex-direction: column;
  justify-content: center;
  .item__title {
    color: #8dc444;
    font-size: 2em;
  }
}

.subscriptions__divider {
  padding: 16px 0;
  text-align: left;
  background: rgb(238, 238, 238);
}

.divider__title {
  margin: 0 0 0 16px;
  font-weight: 600;
}

.item__desc {
  position: absolute;
  right: 20px;
  top: 6px;
  font-size: 20px;
  color: grey;

  &:hover {
    color: #8dc444;
    cursor: pointer;
  }
}
</style>

<script>
import moment from 'moment';

export default {
  props: {
    last_subscription: Object,
    subscriptions: Object,
    routes: Object,
    reached_subscriptions_limit: Boolean,
    show_start_discount_banner: Boolean,
    subscription_buy_disabled: Boolean,
    tooltip_information: Object,
    invoice_missing: Boolean,
  },
  data: () => ({
    expirationDate: null,
  }),
  created() {
    if (this.last_subscription !== null) {
      this.expirationDate = moment(this.last_subscription.end_date).format('DD.MM.Y');
    }
  },
  methods: {
    getPrice(id) {
      return parseFloat(this.subscriptions[id].price);
    },
  },
};
</script>
